export const numberFormatter = Intl.NumberFormat("en", { notation: "compact" });
